let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("12mie")).then(() => parcelRequire('gHN26'));